export const ATTACHMENT_TYPE = {
  AUDIO_RECORDING: 'AudioRecording',
  AUDIO_TRANSCRIPTION_: 'AudioTranscription',
  TEXT: 'Text',
  SOURCE_DOCUMENT: 'SourceDocument',
  RENDERED_DOCUMENT: 'RenderedDocument',
  MMS_ATTACHMENT: 'MmsAttachment',
  FAX_ATTACHMENT: 'FaxAttachment',
};
